module.exports = __webpack_public_path__ + "static/img/4.9c4eda5.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/1/2/sp/4.png
// module id = caPY
// module chunks = 0